module.exports = __webpack_public_path__ + "img/add-new-form.70238d7f.svg";